import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { ProductClassificationModal } from "./components/ProductClassificationModal";
import { useProductClassificationStore } from "../../hooks/useProductClassificationStore";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align:'center' },
];

export const ProductClassificationView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionClassification, getProductClassification, getProductClassificationByCompany, deleteProductClassification } = useProductClassificationStore();

    const [loading, setLoading] = useState(false);
    const [branchOffices, setBranchOffices] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getProductClassificationApi()
    },[])

    const getProductClassificationApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getProductClassification(search);
            if(!response){
                setBranchOffices([]);
                setLoading(false);
                return false;
            }else{
                setBranchOffices(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionClassification('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected:any) => {
        setActionClassification('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected:any) => {
        setActionClassification('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected:any) => {
        setActionClassification('detail');
        setRowSelected(rowSelected);
        setShowModal(true);
    }

    const onDeleteConfirm = async() => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteProductClassification(rowSelected.id)
            if(response){
                getProductClassificationApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getProductClassificationApi(term)}, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable 
                    title={'Clasificación de productos'}
                    columns={columns} 
                    loading={loading}
                    rows={branchOffices || []}
                    onRowClick={() => {}}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Nueva clasificación'}
                    onDetails={onDetails}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onSearch={onSearch}
                    dense
                />
            </Grid>
            {
                showModal && (
                    <ProductClassificationModal
                        open = {showModal}
                        closeModal = {() => {setShowModal(false)}}
                        classificationSelected = {rowSelected}
                        listclassification = {getProductClassificationApi}
                        clearState = {clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
        </>
    )
}